import Swal, {SweetAlertResult} from 'sweetalert2'
import {AlertProps} from '../../data/AlertDefaults'
import {DELETE_MESSAGE, UPDATE_MESSAGE} from '../../../utils/contants'
import {Message} from '../../../_metronic/helpers'
import {
  APIResponse,
  InputErrorType,
  SelectValueType,
  SubmitAPIStatusType,
  TableHeaderDataType,
} from '../../types/OtherTypes'
import {
  ModuleOutput,
  RoleMasterFeatureType,
  RoleMasterInput,
  RoleMasterFeatureInputType,
} from '../../types/AdminModuleTypes'
import API from '../../../api/APIUrl'
import {RoleMasterInitialInput} from '../../data/AdminModuleDefaultData'
import {
  addRoles,
  deleteRoles,
  getFeatures,
  getFeatureLevels,
  getModules,
  getRolesById,
  updateRolesById,
} from '../../../api/AdminAPI'
import {FEATURE_KEYS} from '../../features/featureRegistry'

export const getFeaturesData = (setFeatures: Function, setInputFeatures: Function) => {
  getFeatures().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      const existing = res.data as RoleMasterFeatureType[]
      
      // Define simple module-level permissions only
      const SIMPLE_MODULE_PERMISSIONS = [
        'dashboard',
        'holidays',
        'attendance_management_system', // AMS
        'leave_management_system',      // LMS
        'hiring_access',                // Hiring
        'timesheet_access',             // Timesheet
        'users_registration',           // Users
        'roles',                        // Roles (part of Users)
        'designations',                 // Designations (part of Users)
        'leave_config',                 // Settings - Leave
        'general_config'                // Settings - General
      ]
      
      // Filter to only show simple module permissions (filter by name, not id)
      const filtered = existing.filter(f => SIMPLE_MODULE_PERMISSIONS.includes(f.name))

      let features: any = {}
      filtered.forEach((feature: RoleMasterFeatureType) => {
        features[`${feature.id}`] = false
      })
      setFeatures(filtered)
      setInputFeatures(features)
    } else {
      setFeatures([])
      setInputFeatures({})
    }
  })
}

export const handleFeatureLevelChange = (
  featureLevel: string,
  feature: string,
  inputFeatures: RoleMasterFeatureInputType,
  setInputFeatures: Function
) => {
  // let arr: string[] = inputFeatures[`${feature}`]
  // let isExists = false
  // for (let i = 0; i <= arr.length - 1; i++) {
  //   if (arr[i] === featureLevel) {
  //     arr.splice(i, 1)
  //     isExists = true
  //     break
  //   }
  // }
  // if (!isExists) {
  //   arr.push(featureLevel)
  // }
  setInputFeatures((feature: RoleMasterFeatureInputType) => ({...feature, [`${feature}`]: ''}))
}

export const getFeatureLevel = (setFeatureLevels: Function) => {
  getFeatureLevels().then((res: APIResponse) => {
    if (res.statusCode === 200) {
      setFeatureLevels(res.data)
    } else {
      setFeatureLevels([])
    }
  })
}

export const deleteRole = (
  id: string,
  getRole: Function,
  setRole: Function,
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  setFeatures: Function,
  setInputFeatures: Function,
  setShowForm: Function
) => {
  cancelSubmit(setFormField, setEditId, setInputError, setFeatures, setInputFeatures, setShowForm)
  Swal.fire({...AlertProps, icon: 'warning', title: DELETE_MESSAGE}).then(
    (result: SweetAlertResult) => {
      if (result.isConfirmed) {
        deleteRoles(id).then((res: APIResponse) => {
          if (res.statusCode === 200) {
            getRole(API.ROLES, setRole)
          }
        })
      }
    }
  )
}

export const getRoleByID = async (
  id: string,
  formField: RoleMasterInput,
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  setFeatures: Function,
  setInputFeatures: Function,
  setShowForm: Function
) => {
  // First get all available features
  getFeatures().then((featuresRes: APIResponse) => {
    if (featuresRes.statusCode === 200) {
      // Define simple module-level permissions only (same as getFeaturesData)
      const SIMPLE_MODULE_PERMISSIONS = [
        'dashboard',
        'holidays',
        'attendance_management_system', // AMS
        'leave_management_system',      // LMS
        'hiring_access',                // Hiring
        'timesheet_access',             // Timesheet
        'users_registration',           // Users
        'roles',                        // Roles (part of Users)
        'designations',                 // Designations (part of Users)
        'leave_config',                 // Settings - Leave
        'general_config'                // Settings - General
      ]
      
      // Filter to only show simple module permissions (filter by name, not id)
      const filtered = featuresRes.data.filter((f: RoleMasterFeatureType) => 
        SIMPLE_MODULE_PERMISSIONS.includes(f.name)
      )
      
      setFeatures(filtered)
      
      // Initialize all features as false
      let allFeatures: any = {}
      filtered.forEach((feature: RoleMasterFeatureType) => {
        allFeatures[`${feature.id}`] = false
      })
      
      // Then get the role data and set selected permissions to true
      getRolesById(id).then((res: APIResponse) => {
        if (res.statusCode === 200) {
          setShowForm(true)
          
          // Mark existing permissions as true (only for simple permissions)
          res.data.permissions.forEach((permission: {permission: {id: string}}) => {
            if (allFeatures.hasOwnProperty(permission.permission.id)) {
              allFeatures[`${permission.permission.id}`] = true
            }
          })
          
          setInputFeatures(allFeatures)

          setFormField({
            ...formField,
            roleName: res.data.name,
          })
          setEditId(id)
          setInputError({})
          window.scrollTo(0, 0)
        } else {
          Message(res.message, 'error')
        }
      })
    } else {
      setFeatures([])
      setInputFeatures({})
    }
  })
}

export const handleSubmit = async (
  formField: RoleMasterInput,
  getRole: Function,
  setRole: Function,
  setEditId: Function,
  setFormField: Function,
  editId: string | null,
  setInputError: Function,
  validateForm: Function,
  setFeatures: Function,
  setInputFeatures: Function,
  inputFeatures: RoleMasterFeatureInputType,
  setSubmitAPIStatus: Function,
  setShowForm: Function
) => {
  let permissions: string[] = []

  Object.keys(inputFeatures).forEach((permission) => {
    if (inputFeatures[permission] === true) {
      permissions.push(permission)
    }
  })
  let {cnt, error} = validateForm(formField, permissions)
  setInputError(error)
  if (cnt === 0) {
    if (editId === null) {
      setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: true}))
      addRoles(formField, permissions).then((res: APIResponse) => {
        if (res.statusCode === 201) {
          getRole(API.ROLES, setRole)
          cancelSubmit(
            setFormField,
            setEditId,
            setInputError,
            setFeatures,
            setInputFeatures,
            setShowForm
          )
        }
        setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: false}))
      })
    } else {
      Swal.fire({...AlertProps, icon: 'warning', title: UPDATE_MESSAGE}).then(
        (result: SweetAlertResult) => {
          if (result.isConfirmed) {
            setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: true}))
            updateRolesById(formField, editId, permissions).then((res: APIResponse) => {
              if (res.statusCode === 200) {
                getRole(API.ROLES, setRole)
                cancelSubmit(
                  setFormField,
                  setEditId,
                  setInputError,
                  setFeatures,
                  setInputFeatures,
                  setShowForm
                )
              }
              setSubmitAPIStatus((prev: SubmitAPIStatusType) => ({...prev, loading: false}))
            })
          }
        }
      )
    }
  }
}

export const cancelSubmit = (
  setFormField: Function,
  setEditId: Function,
  setInputError: Function,
  setFeatures: Function,
  setInputFeatures: Function,
  setShowForm: Function
) => {
  setEditId(null)
  getFeaturesData(setFeatures, setInputFeatures)
  setShowForm(false)
  setFormField(RoleMasterInitialInput)
  setInputError({})
}

export const validateForm = (
  formField: RoleMasterInput,
  inputFeatures: {
    permission: {id: string}
    permissionLevel: string[]
  }[]
) => {
  let cnt = 0
  const error: InputErrorType = {}
  let alphaRegex = /^([a-z]+(\s{1})?)+[a-z\d]+$/i
  if (!formField.roleName.trim()) {
    cnt = cnt + 1
    error.roleName = 'Please enter a Role Name.'
  } else {
    if (formField.roleName.trim().length <= 1) {
      cnt = cnt + 1
      error.roleName = 'User Role Name must be greater than 1 characters'
    } else {
      if (!alphaRegex.test(formField.roleName.trim())) {
        cnt = cnt + 1
        error.roleName =
          'User Role Name should start and end with a letter or number. It can contain only letters (A-Z), numbers (0-9), or a single space.'
      } else {
        if (formField.roleName.replaceAll(' ', '').length > 50) {
          cnt = cnt + 1
          error.roleName = 'User Role Name should not be greater than 50 characters'
        }
      }
    }

    if (inputFeatures.length === 0) {
      cnt = cnt + 1
      error.feature = 'Please select at least one Permission.'
    }
  }

  return {error, cnt}
}

// export const handleModuleChange = (
//   value: string | null,
//   setFormField: Function,
//   inputError: InputErrorType,
//   setInputError: Function,
//   setFeatures: Function,
//   setInputFeatures: Function
// ) => {
//   clearInputError('module', inputError, setInputError)
//   if (value !== null) {
//     setFormField((prev: RoleMasterInput) => ({
//       ...prev,
//       module: value,
//     }))
//     getFeaturesByModuleId(value).then((res: APIResponse) => {
//       if (res.statusCode === 200) {
//         let features: RoleMasterFeatureInputType = {}
//         res.data.map((feat: {id: string}) => {
//           features[`${feat.id}`] = []
//         })
//         setFeatures(res.data)
//         setInputFeatures(features)
//       } else {
//         setFeatures([])
//         setInputFeatures({})
//       }
//     })
//   }
// }

export const getModuleData = (setModules: Function) => {
  getModules().then((res: APIResponse) => {
    let Modules: SelectValueType[] = []
    if (res.statusCode === 200) {
      res.data.forEach((obj: ModuleOutput) => {
        Modules.push({label: obj.description, value: obj.id})
      })
      setModules(Modules)
    } else {
      setModules(Modules)
    }
  })
}

export const getRoleTableHeaderData = (isActionColumnNeeded: boolean) => {
  const roleTableHeaderData: TableHeaderDataType[] = [
    {
      th: {
        id: 'name',
        style: {
          minWidth: '150px',
          width: '150px',
          marginLeft: '3px',
        },
      },
      text: 'User Role',
    },
    {
      th: {
        id: 'features',
        style: {
          minWidth: '200px',
          width: '200px',
        },
      },
      text: 'Features & Actions',
      isSortable: false,
    },
  ]
  return {roleTableHeaderData}
}
